import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { GlobalContext } from "../Context/GlobalContext";

export default function PublicRoute() {
  const location = useLocation();

  const { user, authLoading } = useContext(GlobalContext);

  if (authLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-blue-50">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-blue-200 border-t-blue-700" />
      </div>
    );
  }

  if (!user) {
    return <Outlet />;
  }

  const firstName = String(user?.first_name || user?.firstName || "").trim();

  const lastName = String(user?.last_name || user?.lastName || "").trim();

  const privacyPolicy = String(
    user?.privacy_policy || user?.privacyPolicy || "N",
  )
    .trim()
    .toUpperCase();

  const profileCompleted =
    Boolean(firstName) && Boolean(lastName) && privacyPolicy === "Y";

  const requestedPath = location.state?.from;

  if (!profileCompleted) {
    return (
      <Navigate
        to="/profile-details"
        replace
        state={{
          userCode: user?.user_code || user?.userCode || user?.customerId || "",

          number: user?.number || user?.mobile || user?.customerMobile || "",

          user,

          from: requestedPath || null,
        }}
      />
    );
  }

  const redirectPath =
    typeof requestedPath === "string"
      ? requestedPath
      : requestedPath?.pathname
        ? `${requestedPath.pathname}${
            requestedPath.search || ""
          }${requestedPath.hash || ""}`
        : "/";

  return <Navigate to={redirectPath} replace />;
}
